<template>
  <div style="margin-top: 10px;">
    <div style="margin-bottom: 5px;">
      <el-button type="primary" size="small" @click="">下载模板</el-button>
      <el-button type="warning" size="small" @click="">上传</el-button>
    </div>
    <el-table
      stripe
      :header-cell-style="{backgroundColor: '#F4F8FB'}"
      :data="tableData"
      :height="tableHeight"
      v-if="tableHeight"
      v-loading="loading"
    >
      <el-table-column label="图片">
        <template slot-scope="scope" v-if="showDetailBtn(scope.row, 0)">
          <el-link :underline="false" type="primary" @click="showDialog(scope.row, 0)">查看</el-link>
        </template>
      </el-table-column>
      <el-table-column label="SPU编码" prop="" show-overflow-tooltip></el-table-column>
      <el-table-column label="SPU名称" prop="" show-overflow-tooltip></el-table-column>
      <el-table-column label="SPU品类" prop="" show-overflow-tooltip></el-table-column>
      <el-table-column label="SKU编码" prop="" show-overflow-tooltip></el-table-column>
      <el-table-column label="SKU名称" prop="" show-overflow-tooltip></el-table-column>
      <el-table-column label="商品定位" prop="" show-overflow-tooltip></el-table-column>
      <el-table-column label="风格" prop="" show-overflow-tooltip></el-table-column>
      <el-table-column label="类别" prop="" show-overflow-tooltip></el-table-column>
      <el-table-column label="预计上线时间" prop="" show-overflow-tooltip></el-table-column>
      <el-table-column label="上线时间" prop="" show-overflow-tooltip></el-table-column>
      <el-table-column label="更新时间" prop="" show-overflow-tooltip></el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button type="text">上传</el-button>
          <el-button type="text">预览</el-button>
          <el-button type="text">下载</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div style="text-align: right; margin-top: 10px;">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="paginationOpt.pageNum"
        :page-sizes="paginationOpt.pageSizes"
        :page-size="paginationOpt.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="paginationOpt.total">
      </el-pagination>
    </div>
    <!-- 视频、图片查看 -->
    <pic-video v-model="picVideoVisible" :data="rowData" :detailType="viewType" v-if="picVideoVisible"></pic-video>
    <!-- 导入导出 -->
    <import-export ref="importExport" @onsuccess="init"></import-export>
  </div>
</template>

<script>
  import picVideoMxin from './pic&video.mixin'
  import importExportMxin from './import&export.mixin'
  export default {
    mixins: [ picVideoMxin, importExportMxin],
    components: {},
    props: ['tableHeight'],
    data() {
      return {
        loading: false,
        formData: {},
        tableData: [],
        paginationOpt: {
          pageSizes: [30, 60, 90],
          pageSize: 30,
          pageNum: 1,
          total: 0
        }
      }
    },
    mounted() {
      // this.init();
    },
    methods: {
      handleSearch(data) {
        this.paginationOpt.pageNum = 1;
        this.formData = data;
        this.init();
      },
      init() {
        this.loading = true;
        let formData = {
          pageSize: this.paginationOpt.pageSize,
          pageNum: this.paginationOpt.pageNum,
          filterData: {
            ...this.formData
          }
        };
        this.$q.reviewProduct.list(formData)
        .then(res=>{
          this.tableData = res.data.records;
          this.paginationOpt['total'] = res.data.total;
        })
        .finally(_=>{
          this.loading = false;
        })
      },
      // 分页器 pagesize
      handleSizeChange(val) {
        this.paginationOpt.pageSize = val;
        this.paginationOpt.pageNum = 1;
        this.init();
      },
      // 分页器 pageNum
      handleCurrentChange(val) {
        this.paginationOpt.pageNum = val;
        this.init();
      }
    }
  }
</script>
<style lang="stylus" scoped>
</style>